import { TextField } from '@material-ui/core';
import { hideRemindModal, showLoginModal } from 'features/login/store/login.action';
import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import Button from 'shared/components/form/button';
import { APP_URL } from 'shared/constants/common';

import { forgotPassFormValidationSchema } from 'shared/constants/validation-schema';
import { isFieldValueValid, isMobile } from 'shared/util/utility';

interface ForgotPassFormProps {
	initialValues: {
		email: string;
	};
	onSubmit: (data: any) => void;
	handleNavTab: () => void;
	hideRemindModal?: () => void;
	showLoginModal?: () => void;
}

const ForgotPassForm = (props: ForgotPassFormProps) => {
	const { t } = useTranslation();

	const handleBackToLogin = () => {
		props.hideRemindModal?.();
		props.showLoginModal?.();
	};

	return (
		<>
			<p className="mt--0 mb--8 text--uppercase font--semi-bold">{t('forgotPassword')}</p>
			<p className="font--regular font-size--sm mt--0 mb--18">{t('forgotPassHelperText')}:</p>
			<Formik
				enableReinitialize={true}
				initialValues={props.initialValues}
				validationSchema={forgotPassFormValidationSchema()}
				validateOnBlur={true}
				validateOnChange={true}
				onSubmit={props.onSubmit}
			>
				{({ handleSubmit, handleBlur, setFieldValue, setFieldError, values, errors, touched }) => (
					<form onSubmit={handleSubmit}>
						<div className="form__item mb--25">
							<TextField
								variant={'outlined'}
								label={t('email')}
								className={`outlined-item width--full form__input ${isFieldValueValid('email', errors, touched) ? 'error' : ''}`}
								type="email"
								name="email"
								onBlur={handleBlur}
								onChange={(e: any) => {
									const email = e.target.value.trim();
									setFieldValue('email', email);
								}}
								data-cy="email-input"
							/>
							{isFieldValueValid('email', errors, touched) && <p className="no--margin error">{errors.email}</p>}
						</div>
						<div className="button__wrapper mt--15 flex flex--column align__items--center">
							<Button btnHeight="small" cyTestRef="send-button">
								{t('send')}
							</Button>
							{isMobile() || (!isMobile() && window.location.pathname === APP_URL.forgotPassword) ? (
								<div
									className="opacity--30 text-decoration--underline font--medium font-size--12 pointer mb--5"
									onClick={() => props.handleNavTab()}
								>
									{t('login')}
								</div>
							) : (
								<div
									className="opacity--30 text-decoration--underline font--medium font-size--12 pointer mb--5"
									onClick={handleBackToLogin}
								>
									{t('login')}
								</div>
							)}
						</div>
					</form>
				)}
			</Formik>
		</>
	);
};

const mapDispatchToProps = (dispatch: ThunkDispatch<Record<string, unknown>, Record<string, unknown>, Action>) => ({
	hideRemindModal: () => dispatch(hideRemindModal()),
	showLoginModal: () => dispatch(showLoginModal()),
});

export default connect(null, mapDispatchToProps)(ForgotPassForm);
